import React, { useContext, useEffect, useRef, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { UserContext } from '../App'
import { FaUser } from "react-icons/fa6";
import { IoMdNotificationsOutline } from "react-icons/io";
import { BsCart2 } from "react-icons/bs";
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import logo_white from '../assets/img/logo_white.png'
import logo from '../assets/img/logo.png'

export const Navbar = () => {

  const { auth, user, notifications, setNotifications, socket, showModal, setShowModal } = useContext(UserContext)
  const location = useLocation()
  const [bg, setBg] = useState(false)
  const [mobile, setMobile] = useState(false)
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState('')
  const [successMessage, setSuccessMessage] = useState('')
  const panelRef = useRef(null);
  const navigate = useNavigate()

  const changeBackground = () => {
    if (window.scrollY >= 30) {
      setBg(true)
    } else { 
      setBg(false)
    }
  }
  
  useEffect(() => {
    changeBackground()
    // adding the event when scroll change background
    window.addEventListener("scroll", changeBackground)
  }, [])


  useEffect(() => {
    function handleClickOutside(event) {
      if (panelRef.current && !panelRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <>
      <div id="navbar" className={"navbar right-0 left-0 top-0 py-2 z-40 fixed" + (location.pathname === '/' ? " py-[30px]" : " bg-white border-b border-neutral-300") + (location.pathname === '/checkout' ? " absolute" : "")}>
        {location.pathname === '/' && <div className={ (bg || (location.pathname === '/login' || location.pathname === '/signup' || location.pathname === '/reset_password') ? "active md:translate-y-0 translate-y-0 " : "md:translate-y-[-106px] translate-y-[-104px] ") + " h-full transition-[transform, opacity] duration-500 ease-in-out absolute top-0 w-full " + (location.pathname === '/' ? "bg-gradient-to-b from-gray-600 via-gray-600 via-[50%] opacity-50" : "bg-white border-b border-neutral-300") }></div>}
        <div className="z-10 relative">
          <div className="mx-auto">
            <div className={"relative innerContainer mx-auto nav flex items-center sm:gap-10 gap-5 justify-between " + (location.pathname === '/' ? "text-white " : "")}>
              <Link to="/" onClick={() => setMobile(false)}><img src={location.pathname === '/' ? logo_white : logo} className="w-40" /></Link>
              <div className="font-medium nav-items select-none m-auto flex items-center gap-5 justify-between lg:flex hidden text-sm xl:text-base">
                <div className="item relative flex"><Link to="/" className="p-2 relative after:transition-[width] after:duration-300 after:ease-in-out after:content-[''] after:left-0 after:h-[1px] after:absolute after:bottom-0 after:left-0 after:bg-gradient-to-r after:from-emerald-400 after:to-emerald-500 after:w-0 after:hover:w-full">Forside</Link></div>
                <div className="item relative flex"><Link to="/bøger" className="p-2 relative after:transition-[width] after:duration-300 after:ease-in-out after:content-[''] after:left-0 after:h-[1px] after:absolute after:bottom-0 after:left-0 after:bg-gradient-to-r after:from-emerald-400 after:to-emerald-500 after:w-0 after:hover:w-full">Bøger</Link></div>
                <div className="item relative flex"><Link to="/hjælp" className="p-2 relative after:transition-[width] after:duration-300 after:ease-in-out after:content-[''] after:left-0 after:h-[1px] after:absolute after:bottom-0 after:left-0 after:bg-gradient-to-r after:from-emerald-400 after:to-emerald-500 after:w-0 after:hover:w-full">Hjælp</Link></div>
                {/*<div className="item relative flex"><Link to="/kontakt" className="p-2 relative after:transition-[width] after:duration-300 after:ease-in-out after:content-[''] after:left-0 after:h-[1px] after:absolute after:bottom-0 after:left-0 after:bg-gradient-to-r after:from-emerald-400 after:to-emerald-500 after:w-0 after:hover:w-full">Kontakt os</Link></div>*/}
              </div>
              <div className="flex items-center gap-5">
                { auth ? 
                  <>
                    <div className="sm:relative hidden sm:block">
                      <div className="cursor-pointer relative" onClick={() => setDropdownOpen(!dropdownOpen)}>
                        <IoMdNotificationsOutline size="27px" />
                        {typeof notifications !== 'undefined' && notifications.length > 0 ? <div className="select-none w-4 h-4 z-10 absolute bg-emerald-600 rounded-full top-0 -right-1 text-xs text-white text-center font-medium">{notifications.length}</div> : ""}
                      </div>
                      <div ref={panelRef} className={`top-12 sm:top-auto flex flex-col absolute right-0 mt-2 w-full transition-[] bg-white shadow-lg z-20 text-neutral-700 text-sm overflow-hidden ${(dropdownOpen ? "max-h-56 sm:w-96" : "max-h-0 sm:w-0")}`}>
                        <div className="notifications overflow-y-auto">
                          {typeof notifications !== 'undefined' && notifications.length > 0 ?
                            notifications.map(notification => {
                              return (
                                <div className="p-4 cursor-pointer hover:bg-neutral-100" onClick={() => setDropdownOpen(false) & (notification.type === 1 ? navigate(`/indbakke?chatId=${notification.chatId}`) : navigate(`/dashboard/ordre?id=${notification.chatId}`))}>
                                  <h2>Ny besked fra <span className="font-medium text-black">{notification.sender.first_name} {notification.sender.last_name}</span>: "{notification.msg.replace(/\\n/g, " ")}"</h2>
                                </div>
                              )
                            })
                          :
                            <div className="p-4">
                              <h2>Du har ingen nye beskeder</h2>
                            </div>}
                        </div>
                        <div className="border-t border-neutral-300 text-center p-2"><span onClick={() => navigate('/indbakke') & setDropdownOpen(false)} className="font-medium hover:text-emerald-600 cursor-pointer transition-[]">Se alle beskeder</span></div>
                      </div>
                    </div>
                    <FaUser size="22px" className="cursor-pointer" onClick={() => navigate('/dashboard/bøger')} />
                  </>
                : 
                  <div onClick={() => decodeURIComponent(location.pathname).toLowerCase() === '/sælgbog' || location.pathname === '/login' ? navigate('/login') : setShowModal(true)} className="flex items-center gap-1 cursor-pointer">
                    <FaUser size="22px" />
                  </div>
                }
                <Link to="/checkout" className={"sm:inline-flex hidden relative " + ((localStorage.getItem('basket') ? localStorage.getItem('basket').split(",").length : []) > 0 ? "mr-2" : "")}>
                  <BsCart2 size="25px" />
                  {(localStorage.getItem('basket') ? localStorage.getItem('basket').split(",").length : []) > 0 ? <div className="select-none w-4 h-4 z-10 absolute bg-emerald-600 rounded-full -top-1 -right-2 text-xs text-white text-center font-medium">{localStorage.getItem('basket').split(",").length}</div> : ""}
                </Link>
                <Link to="/sælgbog" className="md:inline-flex hidden">
                  <button className="select-none text-nowrap bg-size-200 bg-pos-0 hover:bg-pos-100 justify-center w-auto px-4 py-2 text-sm font-medium leading-5 text-white transition-all duration-150 ease-in-out bg-gradient-to-r from-emerald-600 to-emerald-700" type="button" aria-haspopup="true" aria-expanded="true" aria-controls="headlessui-menu-items-117">
                    <span>Sælg bog</span>
                  </button>
                </Link>
                <div id="hamburger" className="hamburger bg-gradient-to-r from-emerald-600 to-emerald-800 transition-[] bg-size-200 bg-pos-0 hover:bg-pos-100 cursor-pointer lg:hidden ml-auto flex flex-col gap-1.5 p-2.5" onClick={() => setMobile(!mobile)}>
                  <div className={`w-8 h-1 bg-white rounded-full transition-[rotate, transform] duration-500 ${mobile ? "rotate-45 translate-y-2.5" : "" }`}></div>
                  <div className={`w-8 h-1 bg-white rounded-full transition-[opacity] duration-200 ${mobile ? "opacity-0" : "" }`}></div>
                  <div className={`w-8 h-1 bg-white rounded-full transition-[rotate, transform] duration-500 ${mobile ? "-rotate-45 -translate-y-2.5" : "" }`}></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={"mobileNav lg:hidden w-full h-lvh z-20 bg-white fixed transition-[transform] duration-500 ease-in-out flex flex-col justify-center gap-5 text-lg " + (mobile ? "" : "-translate-x-full")}>
        <div className="font-medium nav-items items-center px-5 gap-5 justify-between flex flex-col">
          <div className="item relative flex"><Link to="/" onClick={() => setMobile(false)} className="p-2 relative after:transition-[width] after:duration-300 after:ease-in-out after:content-[''] after:left-0 after:h-[2px] after:absolute after:bottom-0 after:left-0 after:bg-emerald-400 after:w-0 after:hover:w-full">Forside</Link></div>
          <div className="item relative flex"><Link to="/bøger" onClick={() => setMobile(false)} className="p-2 relative after:transition-[width] after:duration-300 after:ease-in-out after:content-[''] after:left-0 after:h-[2px] after:absolute after:bottom-0 after:left-0 after:bg-emerald-400 after:w-0 after:hover:w-full">Bøger</Link></div>
          { auth ? 
            <>
              <Menu as="div" className="block sm:hidden relative inline-block text-left">
                <div>
                  <MenuButton className="w-auto bg-size-200 bg-pos-0 hover:bg-pos-100 items-center inline-flex justify-center py-2 text-base leading-5">
                    <div className="flex items-center gap-2">
                      <span className="">{user.first_name}</span>
                      <div className="flex items-center gap-1">
                        <FaUser size="20px" />
                        <svg className="w-5 h-5" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg>
                      </div>
                    </div>
                  </MenuButton>
                </div>
          
                <MenuItems
                  transition
                  className="absolute left-[50%] translate-x-[-50%] z-10 mt-2 w-56 origin-top-right divide-y divide-gray-100 bg-white shadow-lg transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                >
                  <div className="">
                    <Link to="/dashboard/minebøger">
                      <MenuItem onClick={() => setMobile(false)}>
                        <div
                          className="cursor-pointer block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900"
                        >
                          Mine bøger
                        </div>
                      </MenuItem>
                    </Link>
                    <Link to="/indbakke">
                      <MenuItem onClick={() => setMobile(false)}>
                        <div
                          className="cursor-pointer block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900"
                        >
                          Beskeder
                        </div>
                      </MenuItem>
                    </Link>
                    <Link to="/dashboard/saldo">
                      <MenuItem onClick={() => setMobile(false)}>
                        <div
                          className="cursor-pointer block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900"
                        >
                          Saldo
                        </div>
                      </MenuItem>
                    </Link>
                    <Link to="/dashboard/indstillinger">
                      <MenuItem onClick={() => setMobile(false)}>
                        <div
                          className="cursor-pointer block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900"
                        >
                          Indstillinger
                        </div>
                      </MenuItem>
                    </Link>
                  </div>
                  <div className="">
                    <MenuItem onClick={() => navigate('/logout')}>
                      <div
                        className="cursor-pointer block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900"
                      >
                        Log ud
                      </div>
                    </MenuItem>
                  </div>
                </MenuItems>
              </Menu>
              <Link to="/sælgbog" onClick={() => setMobile(false)}>
                <button className="select-none text-nowrap bg-size-200 bg-pos-0 hover:bg-pos-100 md:inline-flex justify-center w-auto px-4 py-2 text-sm font-medium leading-5 text-white transition-all duration-150 ease-in-out bg-gradient-to-r from-emerald-600 to-emerald-700" type="button" aria-haspopup="true" aria-expanded="true" aria-controls="headlessui-menu-items-117">
                  <span>Sælg bog</span>
                </button>
              </Link>
            </>
          : 
            <Link to="/login" onClick={() => setMobile(false)}>
              <button className="select-none text-nowrap bg-size-200 bg-pos-0 hover:bg-pos-100 md:inline-flex justify-center w-full px-4 py-2 text-sm font-medium leading-5 text-white transition-all duration-150 ease-in-out bg-gradient-to-r from-emerald-600 to-emerald-700" type="button" aria-haspopup="true" aria-expanded="true" aria-controls="headlessui-menu-items-117">
                <span>Login</span>
              </button>
            </Link>
          }
        </div>
      </div>
    </>
  )
}